import { Box, Typography } from "@dealer-center/core-components";
import { PagesAccountSwitcherUiUiInputNew } from "./Input";

export const PagesAccountSwitcherUiUiDisplayNew = () => {
  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography variant={"h1"}>AccountSwitcherUi</Typography>
        <Typography variant={"body-md"}>
          Here is some basic content for your site
        </Typography>
      </Box>
      <PagesAccountSwitcherUiUiInputNew />
    </Box>
  );
};
